import React from 'react';

/**
 * FilterTabs Component
 */
const FilterTabs = ({ activeFilter, onFilterChange, counts }) => {
  const filters = [
    { key: 'All', label: 'All', count: counts?.all || 0 },
    { key: 'Upcoming', label: 'Upcoming', count: counts?.upcoming || 0 },
    { key: 'Completed', label: 'Completed', count: counts?.completed || 0 },
    { key: 'Missed', label: 'Missed', count: counts?.missed || 0 },
    { key: 'Incomplete', label: 'Incomplete', count: counts?.incomplete || 0 },
    { key: 'Cancelled', label: 'Cancelled', count: counts?.cancelled || 0 },
  ];

  return (
    <div className="inline-flex max-w-full items-center gap-1 p-1 bg-white rounded-xl border-[1px] border-solid border-[#E2E8F0] shadow-sm overflow-x-auto scrollbar-hide">
      {filters.map((filter) => (
        <button
          key={filter.key}
          onClick={() => onFilterChange(filter.key)}
          className={`px-[14px] h-[34px] rounded-lg border-0 text-xs md:text-[13px] font-semibold font-poppins transition-all whitespace-nowrap flex-shrink-0 ${
            activeFilter === filter.key
              ? 'bg-[#0F172A] text-white shadow-md'
              : 'bg-[#F8FAFC] text-[#334155] hover:bg-gray-100'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default FilterTabs;
